import React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

type LoaderProps = {
  loading: boolean;
  progress?: number;
  uploadStatus?: 'initial' | 'loading' | 'success' | 'error';
};

export const Loader = ({ loading, progress }: LoaderProps) => {
  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.drawer + 9999,
        backdropFilter: 'blur(4px)',
        bgcolor: 'rgba(0, 0, 0, 0.4)',
      }}
      open={Boolean(loading)}
    >
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <CircularProgress
          variant={progress !== undefined ? 'determinate' : 'indeterminate'}
          value={progress}
          size={56}
          thickness={4}
          sx={{
            color: 'primary.main',
          }}
        />
      </Box>
    </Backdrop>
  );
};
